import { useHasValidLicense } from "@cs_teamwaydev/mailvista-sdk_react";

const useLicenseCheck = () => {
    // Pas de redirection ici : quand la licence est invalide,
    // CheckLicense rend NoLicenseScreen (écran dédié avec message spécifique).
    const { data: hasValidLicense, isLoading } = useHasValidLicense();

    return { hasValidLicense, isLoading };
};

export default useLicenseCheck;
